<template>
    <form class="default-form"
          method="GET"
          :action="route"
    >
        <input
               type="text"
               name="s"
               v-model="query"
               @input="input = true"
               autocomplete="off"
               :placeholder="inputPlaceholder"
        >
        <button type="submit">
            <img v-bind:src="buttonText" v-svg-inline>
        </button>

        <div v-if="hasResults"
             v-html="resultList"
        >
        </div>
    </form>
</template>

<script>
import { ref, watch } from 'vue'
import axios from 'axios';

export default {

    props: {
        route: {
            required: true,
            type: String
        },
        inputPlaceholder: {
            required: false,
            type: String
        },
        buttonText: {
            required: false,
            type: String
        }
    },

    setup(props) {

        const input      = ref(false),
              hasResults = ref(false),
              resultList = ref(''),
              query      = ref('');

        watch( () => input.value, () => {

            if ( input.value === true) {
                input.value = false
                setTimeout( () => sendAjax(), 250)
            }
        })

        function sendAjax() {
            if ( query.value.length > 2 ) {
                axios.post(props.route,{ q: query.value })
                    .then( response => {

                        resultList.value = response.data;

                        if ( resultList.value.length > 0 )
                            hasResults.value= true
                    })
                    .catch( error => console.error(error) )
            } else hasResults.value = false;
        }

        return {
            props,
            input,
            query,
            hasResults,
            resultList,
            sendAjax
        }
    }
}
</script>
